<div *ngIf="!user"> -</div>
<div *ngIf="user" class="flex items-baseline m-1">
  {{user.name.substring(0, 40)}}
  <span *ngIf="user.name && user.email" class="mx-1"> | </span>
  {{user.email.substring(0, 40)}}
</div>
<div class="italic m-1">{{user.organization?.name?.substring(0, 30) || ('user.unregistered' | translate)}}</div>

